var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlinkoMisicIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 18,
    viewBox: "0 0 12 18",
    fill: "#EB48FF",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.028 11.4474C11.5664 10.5113 11.9236 9.32739 11.9929 8.1559C12.0369 7.40399 11.8756 6.61469 11.5265 5.87247C10.9787 4.70652 10.0378 4.05154 9.12895 3.41871C8.45061 2.94651 7.80958 2.50063 7.35647 1.86365L7.27517 1.7501C7.0073 1.37622 6.70478 0.952493 6.6568 0.596615C6.60883 0.236583 6.29431 -0.0195934 5.95048 0.00117766C5.60131 0.0261029 5.33077 0.326591 5.33077 0.690777V10.9231C5.33077 11.8378 4.24643 12.461 3.33173 12.461C1.49528 12.461 0 13.7032 0 15.2305C0 16.7579 1.49528 18 3.33173 18C5.16819 18 6.66347 16.7579 6.66347 15.2305V11.1642C6.66347 9.24412 8.72407 8.10448 9.44615 9.88361C9.52303 10.073 9.59145 10.2742 9.64972 10.4877C9.72701 10.7709 9.68455 11.0872 9.49544 11.3117C9.25156 11.5984 9.27821 12.0359 9.55541 12.288C9.82995 12.5427 10.2511 12.5123 10.495 12.2256C10.6581 12.0334 10.8045 11.8111 10.9444 11.5777C10.971 11.5335 11.0027 11.4924 11.028 11.4474Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlinkoMisicIcon);
export default __webpack_public_path__ + "static/media/plinko-misic-icon.aea12316379bae7d96b98dac485ccbdb.svg";
export { ForwardRef as ReactComponent };